import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const Field = ({ id, label, value, onChange, type = "text", placeholder, required, testId }) => (
    <div className="space-y-2">
        <Label htmlFor={id} className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
            {label}
            {required && <span className="ml-1 text-foreground">*</span>}
        </Label>
        <Input
            id={id}
            data-testid={testId}
            type={type}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder={placeholder}
            className="rounded-sm border-border bg-card font-sans"
        />
    </div>
);

export default Field;
